import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import { Box, IconButton } from '@mui/material';
import { useModules } from '@schamburg-web/components';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import React, { useEffect, useRef } from 'react';
import LayerChooser from '../LayerChooser/LayerChooser';

interface LayerControlProps {
  controlPosition: ControlPosition;
}

const LayerControl: React.FC<LayerControlProps> = ({ controlPosition }) => {
  const { layerControlOpen, toggleLayerControl } = useModules();
  const controlRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (layerControlOpen && controlRef.current && !controlRef.current.contains(event.target as Node)) {
        toggleLayerControl();
      }
    };

    if (layerControlOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [layerControlOpen, toggleLayerControl]);

  return (
    <MapControl position={controlPosition}>
      <Box
        ref={controlRef}
        sx={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        {layerControlOpen && <LayerChooser />}
        <Box className="map-control">
          <IconButton
            title="Layer Control"
            aria-label="Layer Control"
            className={
              layerControlOpen
                ? 'map-control-on map-control-icon-large'
                : 'map-control-off map-control-icon-large'
            }
            onClick={() => toggleLayerControl()}
          >
            <LayersOutlinedIcon sx={{ fontSize: '28px' }} />
          </IconButton>
        </Box>
      </Box>
    </MapControl>
  );
};

export default LayerControl;
